import { createStore } from 'vuex'
import axios from 'axios';


export default createStore({
	plugins: [],
	state: {
		language: 'en',
		selectedFilter: null,
		data: {},
		filteredData: []
	},
	getters : {
		getFilterById: (state) => (id) => { 
			let index = state.data.themas.findIndex(t => t.id === id)
			if(index === undefined) return;
			return state.data.themas[index];
		},

		getSelectedThemeId: (state) => state.selectedFilter ? state.selectedFilter.id : '0'
	},
	mutations: {
		updateFilter (state, thema) {
			debugger;
			state.selectedFilter = thema;
			window.document.body.style.background = '#' + thema.color;

			state.filteredData = state.data.articles.filter(a => {
				return a.themas.findIndex(at => at.id === thema.id) >= 0 ? true: false;
			});
		},

		resetFilter(state) {
			state.selectedFilter = null;
			state.filteredData = state.data.articles;
			window.document.body.style.background = '';
		},

		setData(state, data) {
			state.data = data;
			state.filteredData = data.articles;

		}
	},
	actions:{
		updateFilter({ commit, state }, data){
			commit('updateFilter', data.thema);
		},

		resetFilter({ commit, state }){
			commit('resetFilter');
		},

		fetchContent({ commit })  {     
		return new Promise((resolve, reject) => {
				axios
				.get(process.env.VUE_APP_API)
				.then( (response) => {

					response.data.articles.sort(function(a,b){
						return new Date(b.datum) - new Date(a.datum);
					});


					commit("setData", response.data);
					resolve();
				})
				.catch( (error) => {
					console.log(error.statusText)
				});
			});
		}		
	},
});


